import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "senges",
        nomePrefeitura: "Prefeitura Municipal de Sengés",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/senges/logos/logo.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/senges/logos/logo.png",
        municipio: "| SENGÉS - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: "-",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-49.4715154, -24.1153589],
            zoom: 18,
        },
    },
    api: {
        url: "https://api-staging.semv.com.br/",
    },
    geoserver: {
        url: "https://geoserver.semv.com.br/geoserver",
    },
} as IEnv;
